import styled from "styled-components";
import { colors } from "../../../../../theme/theme";

export const HistoryWrapper = styled.div`
	.p-datatable {
		margin-top: 24px;
		padding-right: 24px;

		.p-datatable-thead > tr > th {
			background: transparent;
			border: 0;

			font-size: 13px;

			.p-sortable-column-icon {
				font-size: 10px;
			}
		}

		.p-datatable-tbody > tr {
			background: #f6f7fb;
			color: ${colors.greyscale.darker_grey};

			font-size: 14px;
			border-bottom: 8px solid #fff;
		}
	}
`;
